import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, Button, Popconfirm, Icon, Divider } from 'antd';
import axios from 'axios';
import { Link } from 'react-router-dom';
// import * as actions from './src/store/actions/auth.js';

const API_HOST_URL = process.env.REACT_APP_API_URL

class User extends Component{

  state = {
    users: []
  }

  columns = [
    {
      title: 'ID',
      dataIndex: 'id',
      key: 'id',
      render: (id) => <a href={`user/${id}`}>{id}</a>,
    },
    {
      title: 'Username',
      dataIndex: 'username',
      key: 'username'
    },
    {
      title: 'First Name',
      dataIndex: 'first_name',
      key: 'first_name',
    }, {
      title: 'Last Name',
      dataIndex: 'last_name',
      key: 'last_name',
    },
    {
      title: 'Active',
      dataIndex: 'is_active',
      key: 'is_active',
      render: (isActive) => <span>{isActive==true?'True':'False'}</span>
    },
    {
      title: 'Last Login',
      dataIndex: 'last_login',
      key: 'last_login',
    },
    // {
    //   title: 'Action',
    //   key: 'action',
    //   fixed: 'right',
    //   width: 100,
    //   render: (record) => (
    //     <span>
    //     <a href="javascript:;" onClick={() => this.handleEdit(record)}><Icon type="edit" /></a>
  
    //     <Divider type="vertical" />
  
    //     {this.state.users.length >= 1
    //       ? (
    //         <Popconfirm title="Sure to delete?" onConfirm={() => this.handleDelete(record)}>
    //           <a href="javascript:;"><Icon type="delete" /></a>
    //         </Popconfirm>
    //       ) : null}
    //       </span>
    //   ),
  
    // }
  ];
    

  handleEdit = record => {
    // this.setState({division: record});
    // this.showModal('put');
}

handleDelete = (record) => {
  // const datalist = [...this.state.datalist];

  return axios.delete(`${API_HOST_URL}/api/systemsetup/user/${record.id}/`)
              .then(res => {
                console.log(res)

                // this.setState({ visible: false });
                this.fetchData()
                // this.props.history.push("/user");
          })
              .catch(error => console.err(error));
}
   
  componentDidMount(){
      this.fetchData();
  }

  fetchData(){
    axios.get(`${API_HOST_URL}/api/systemsetup/user/`)
      .then(res => {
        this.setState({
          users: res.data
        })
        console.log(res.data);
      })
  }

    render(){
        return(
          <div>
           {
              this.props.userPermissions.indexOf('add_user') > -1 ?
              <a><Link to="/user/new">Add User</Link></a>
              : ''
           }

           {
              this.props.userPermissions.indexOf('view_user') > -1 ?
              <Table columns={this.columns} dataSource={this.state.users} rowKey="id" />
              : 'You do not have rights to view users. Please Contact your Administrator'
           }
          </div>
            
        );
    }
}

const mapStateToProps = state => {
  return {
    isAuthenticated: state.token !== null,
    userPermissions: state.userPermissions
  }
}

export default connect(mapStateToProps, null)(User);
// export default User;